import React, { createContext, useContext } from "react";
import { useMatch } from "react-router-dom";
import { usePresenceSession } from "../hooks/useCasePresence";
import { PresenceContextData, PresenceTarget } from "../types/Presence";

const emptyPresenceContext: PresenceContextData = {
  presenceUsers: [],
  otherPresenceUsers: [],
  isPresenceLoading: false,
  isPresenceLive: false,
  presenceError: null,
};

const PresenceProviderContext = createContext<PresenceContextData>(emptyPresenceContext);

const getCasePresenceTarget = (productId: string | undefined): PresenceTarget | null => {
  if (!productId) {
    return null;
  }

  const parsedProductId = parseInt(productId, 10);

  return parsedProductId > 0 ? `cases/${parsedProductId}` : null;
};

export default function PresenceProvider({ children }: { children?: React.ReactNode }) {
  const servicesCaseMatch = useMatch("/services/fall/:productUrlPart/:productId/*");
  const callcenterCaseMatch = useMatch("/services/callcenter/fall/:productUrlPart/:productId/*");
  const externalCaseMatch = useMatch("/services/extern/fall/:productUrlPart/:productId/*");
  const caseMatch = servicesCaseMatch ?? callcenterCaseMatch ?? externalCaseMatch;
  const beaToolMatch = useMatch("/services/tools/bea");
  const documentReviewToolMatch = useMatch("/services/tools/dokumente-pruefen");
  let presenceTarget = getCasePresenceTarget(caseMatch?.params.productId);

  if (presenceTarget === null && beaToolMatch !== null) {
    presenceTarget = "tools/bea";
  }

  if (presenceTarget === null && documentReviewToolMatch !== null) {
    presenceTarget = "tools/dokumente-pruefen";
  }

  const presenceData = usePresenceSession(presenceTarget);

  return <PresenceProviderContext.Provider value={presenceData}>{children}</PresenceProviderContext.Provider>;
}

export const usePresence = () => {
  return useContext(PresenceProviderContext);
};
